import { z } from 'zod';

// Shared building blocks of the response schemas (not part of the `@/api/schemas` surface).
export const str = z.string();
export const nstr = z.string().nullish();
export const nint = z.number().nullish();
